<template>
  <section v-if="order" class="order-confirmation energy-flow-container ">
    <div class="energy-flow-view">
      <div class="layout-content">
        <section class="part mobile-span top-header-container">
          <section class="part-content">
            <h3 class="central-heading">
              We gaan voor je aan de slag
            </h3>
            <ul class="numbered-list card">
              <li v-for="(listItem, index) in summaryList" :key="listItem" class="list-item">
                <span class="counter"> {{ index + 1 }} </span>
                <span class="label"> {{ listItem }} </span>
              </li>
            </ul>
          </section>
        </section>

        <section class="part">
          <section class="part-content">

            <OrderFeedback v-if="orderStore.submittedOrder">
            </OrderFeedback>

          </section>
        </section>
        <section class="part">
          <section class="part-content">
            <h3>Goed om te weten</h3>

            <collapse v-if="!order.moving_in" :start-open="true">
              <template #toggle>
                <div slot="toggle" class="toggle-label">
                  <icon class="label-icon" icon="x-fa-empty-set" size="sm" />
                  <span class="label">{{ product.provider_name }} zegt je huidige contract
                    op</span>
                </div>
              </template>
              <template #content>
                <p>
                  {{ product.provider_name }} gaat aan de slag om alles in orde
                  te maken. Ze zeggen ook het contract bij je oude leverancier
                  voor je op. Je hoeft hier zelf
                  dus niets voor te doen. Je komt nooit zonder gas of stroom te
                  zitten.
                </p>
              </template>
            </collapse>

            <collapse :start-open="false">
              <template #toggle>
                <div slot="toggle" class="toggle-label">
                  <icon class="label-icon" icon="x-fa-file-contract" size="sm" />
                  <span class="label">
                    {{ product.provider_name }} laat weten wanneer je contract
                    in gaat
                  </span>
                </div>
              </template>
              <template #content>
                <p>
                  {{ product.provider_name }} stuurt je in de bevestigingsmail
                  de definitieve ingangsdatum van je contract. Zij proberen zo
                  goed mogelijk rekening te houden met de door jouw ingevulde
                  ingangsdatum.
                </p>
              </template>
            </collapse>
            <collapse :start-open="false">
              <template #toggle>
                <div class="toggle-label">
                  <icon class="label-icon" icon="x-fa-pencil" size="sm" />
                  <span class="label">Je kunt altijd nog je gegevens wijzigen</span>
                </div>
              </template>
              <template #content>
                <p>
                  Heb je per ongeluk iets verkeerds ingevuld tijdens het
                  aanmelden? Geen zorgen, je kunt je gegevens altijd eenvoudig
                  wijzigen. Neem contact op met
                  {{ product.provider_name }} om je gegevens te wijzigen.
                </p>
              </template>
            </collapse>


          </section>
        </section>

      </div>
      <sidebar>
        <template #content>
          <div v-if="order.moving_in" class="tip">
            <section class="desktop-tip">
              <h5>Gefeliciteerd met je nieuwe woning!</h5>
              <span class="tip-text">De energieleverancier voor je nieuwe woning is afgesloten! Verder alles al geregeld
                voor de verhuizing?</span>
              <div class="tip-text">
                Misschien heb je wat aan deze pagina's:
                <ul>
                  <li>
                    <a href="/internet">Internet vergelijken</a>
                  </li>
                  <li>
                    <a href="/woonverzekering">Woonverzekering vergelijken</a>
                  </li>
                  <li>
                    <a href="/inboedelverzekering-vergelijken">Inboedelverzekering vergelijken</a>
                  </li>
                </ul>
              </div>
              <div class="tip-text">
                Of bekijk <a href="/">alle diensten </a> die wij vergelijken. Zo heb je het altijd
                Lekker geregeld in je nieuwe woning!
              </div>
            </section>
          </div>
          <div v-else class="tip">
            <section class="desktop-tip">
              <h5>Wil je nog meer geld besparen?</h5>
              <span class="tip-text">Wist je dat je veel geld kunt besparen op vaste lasten door regelmatig te
                <strong>vergelijken</strong>?</span>
              <span class="tip-text">Je kan bij ons ook eenvoudig <a href="/internet">Internet</a>, <a
                  href="/sim-only">Sim Only</a> en nog <a href="/"> veel meer </a> vergelijken! </span>
            </section>
          </div>
        </template>
      </sidebar>
    </div>
  </section>
</template>

<script>
import Sidebar from '../components/Sidebar.vue';
import Icon from '../../../vue-elements/icon/Icon.vue';
import Collapse from '../../../../abstracts_depr/elements/collapse/collapse.vue';
import KeuzeConfetti from '../../../../assets/js/helpers/confetti.js';
import { useOrderStore } from '../stores/orderStore.js';
import OrderFeedback from '../components/OrderFeedback.vue';

export default {
  components: {
    Sidebar,
    Collapse,
    Icon,
    OrderFeedback,
  },
  setup() {
    const orderStore = useOrderStore();

    return { orderStore };
  },
  data() {
    return {
      confirmationData: Array,
    };
  },
  computed: {
    order() {
      return this.orderStore.submittedOrder;
    },
    product() {
      return this.orderStore.submittedOrder.product;
    },
    orderId() {
      return this.confirmationData.order_id;
    },
    summaryList() {
      const list = [
        `Je krijgt een bevestigingsmail op ${this.orderStore.customer_email}`,
        `Je ontvangt binnen enkele dagen van ${this.product.provider_name} je nieuwe contract`,
      ];

      if (this.orderStore.moving_in) {
        list.push('Je hebt altijd energie in je nieuwe huis');
      } else if (this.orderStore.current_provider === 'no-provider') {
      } else {
        list.push(
          `${this.product.provider_name} zegt je contract bij je oude leverancier op`,
        );
      }

      return list;
    },
  },
  created() {
    this.confirmationData = window.sessionStorage.getItem('keuze-energy-order-confirmation')
      ? JSON.parse(window.sessionStorage.getItem('keuze-energy-order-confirmation'))
      : {};
  },
  mounted() {
    setTimeout(() => {
      const confetti = new KeuzeConfetti({
        element: document.body,
        destroyCanvas: true,
        duration: 3000,
        confettiPieces: 100,
      });
    }, 100);

    this.$emit('updateAddressBar', `Het is gelukt ${this.orderStore.customer_first_name}!`);

    window.ctzReady.then(() => {
      window.contenzi.event({ name: 'Conversion' });
    });
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/scss/_helpers/typography';
@use 'assets/scss/_variables/colors';
@use 'assets/scss/_helpers/display';
@use 'assets/scss/_helpers/breakpoint';
@use 'abstracts_depr/elements/collapse/collapse';


.confirmation-image {
  float: right;
}

.sidebar {
  display: block;
  border-top: 0;
}

.top-header-container {
  @include breakpoint.up(xl) {
    background: #fff;
    padding-top: 48px;
  }
}

.confirmation-message {
  background: colors.$block-blue-100;
  color: white;
  padding: 0 16px;
  position: relative;

  .message {
    position: relative;

    @include breakpoint.down(md) {
      @include display.flex-col-center;
    }
  }

  .header-text {
    @include display.flex-col-center;
    text-align: center;

    @include breakpoint.up(md) {
      padding: 64px 0;
      @include display.flex-row-start;
    }

    @include breakpoint.up(xl) {
      padding-left: 24px;
      padding-right: 24px;
      max-width: unset;
      text-align: left;
      //margin-left: 24px;
    }
  }

  h2 {
    margin-top: 40px;
    position: relative;
    z-index: 1;

    @include breakpoint.up(md) {
      margin: 0;
      text-align: left;
    }

    @include breakpoint.up(xl) {}
  }

  .confirmation-image {
    @supports (max-width: clamp(164px, 50vw, 264px)) {
      max-width: clamp(164px, 20vw, 213px);
      width: 100%;
      height: auto;
      z-index: 0;
    }

    @supports not (max-width: clamp(164px, 50vw, 264px)) {
      max-width: 164px;

      @include breakpoint.up(lg) {
        max-width: 264px;
        right: 64px;
      }
    }

    @include breakpoint.up(md) {
      position: absolute;
      right: 0;
      bottom: 0;
    }

    @include breakpoint.up(xl) {
      right: 64px;
    }
  }
}

.part {
  &.mobile-span {
    @include breakpoint.down(sm) {
      padding-left: 0;
      padding-right: 0;
    }
  }

  padding-left: 16px;
  padding-right: 16px;

  padding-top: 40px;
  padding-bottom: 40px;

  @include breakpoint.up(xl) {
    padding-left: 0;
    padding-right: 56px;
    border-right: 1px solid colors.$border-base;
    margin-left: 24px;

    +.part {
      border-top: 1px solid colors.$border-base;
    }
  }


  &:nth-of-type(1) {
    @include breakpoint.down(sm) {
      padding-top: 16px;
      padding-bottom: unset;
    }
  }

  @include breakpoint.up(lg) {
    padding-top: 48px;
    padding-bottom: 48px;
  }

}

.header-text,
.part-content {
  max-width: 560px;
  padding-right: 0;
  margin: auto;

  @include breakpoint.up(md) {
    margin: auto;
  }

  @include breakpoint.up(xl) {
    margin: 0;
  }
}

h3 {
  margin-bottom: 0;
  text-align: center;
  margin-bottom: 16px;

  @include breakpoint.up(md) {
    text-align: left;
  }
}

.central-heading {
  @include breakpoint.down(sm) {
    @include typography.header-6;
  }
}

.subtitle {
  @include typography.intro-medium;
  display: block;
  margin-bottom: 24px;

  @include breakpoint.up(lg) {
    @include typography.subtitle-medium;
  }
}

.layout-sidebar-right {
  @include breakpoint.up(xl) {
    display: grid;
    grid-template-columns: 1fr 336px;
    column-gap: 48px;
    padding-top: 80px;
    padding-bottom: 80px;
  }
}

.numbered-list {
  list-style: none;
  padding: 0;

  @include breakpoint.down(sm) {
    border-radius: 0;
  }

  .list-item {
    @include display.flex-row-start;
    @include typography.content-short;

    padding: 16px;

    &:not(:last-child) {
      border-bottom: 1px solid colors.$border-base;
    }
  }

  .counter {
    $number-size: 22px;
    @include typography.content-small-strong;
    @include display.flex-col-center;
    margin-right: 8px;
    min-width: $number-size;
    height: $number-size;
    border-radius: 50%;
    border: 2px solid colors.$text-positive;
    color: colors.$text-positive;
  }
}

.layout-content {
  background-color: #fff;


}

.collapse-container {
  margin-bottom: 16px;
}

.toggle-label {
  color: colors.$link-base-default;
}

.label-icon {
  @include breakpoint.down(sm) {
    display: none;
  }

  background-color: currentColor;
  margin-right: 4px;
}
</style>
